export const priorityRank = { Critical: 0, High: 1, Medium: 2, Low: 3, None: 4 };

export const taskTypes = [
  { value: "Accounts",      label: "💰 Accounts"      },
  { value: "Admin",         label: "🗄️ Admin"          },
  { value: "General",       label: "📋 General"        },
  { value: "Authorisation", label: "🖋️ Authorisation"  },
  { value: "Content",       label: "✍️ Content"        },
  { value: "Emails",        label: "✉️ Emails"         },
  { value: "Family",        label: "🧑‍🧒‍🧒 Family"        },
  { value: "Health",        label: "🏥 Health"         },
  { value: "Invoices",      label: "🧾 Invoices"       },
  { value: "Meeting",       label: "🤝 Meeting"        },
  { value: "Operations",    label: "📦 Operations"     },
  { value: "Personal",      label: "🧘‍♀️ Personal"       },
  { value: "Planning",      label: "🗓️ Planning"       },
  { value: "PR/Media",      label: "📣 PR/Media"       },
  { value: "Product",       label: "💻 Product"        },
  { value: "Reporting",     label: "📊 Reporting"      },
  { value: "Sick",          label: "🤒 Sick"           },
  { value: "Strategy",      label: "📈 Strategy"       },
  { value: "Team",          label: "🧑‍💻 Team"           },
  { value: "Thinking Time", label: "🧠 Thinking Time"  },
  { value: "Travel",        label: "✈️ Travel"         },
  { value: "Vacation",      label: "🏖️ Vacation"       },
];

// ✅ Export taskTypes as a map for faster lookups
export const taskTypesMap = taskTypes.reduce((map, type) => {
  map[type.value] = type;
  return map;
}, {});

// ✅ Add helper to check if a value is a valid task type
export const isValidTaskType = (value) => {
  if (!value || typeof value !== 'string') return false;
  return taskTypesMap.hasOwnProperty(value);
};

// ✅ Helper to get task type label safely
export const getTaskTypeLabel = (value) => {
  if (!isValidTaskType(value)) return '📋 Unknown';
  return taskTypesMap[value].label;
};

export const validViewOptions = ["Tasks", "Calendar", "Today", "Tomorrow", "Week View", "List", "Time Blocks", "Schedule", "Contacts", "Invoices"];

// Personal workspace task categories — shown in personal Add Task / Family Calendar.
// Business types (Invoices, Accounts, etc.) are never shown in personal workspace.
export const personalTaskTypes = [
  { value: "Task",        label: "📋 Task"        },
  { value: "Chore",       label: "🧹 Chore"       },
  { value: "Appointment", label: "🏥 Appointment"  },
  { value: "Club",        label: "⚽ Club"         },
  { value: "School",      label: "🎒 School"       },
  { value: "Errand",      label: "🛒 Errand"       },
  { value: "Event",       label: "🎉 Event"        },
  { value: "Birthday",    label: "🎂 Birthday"     },
  { value: "Holiday",     label: "🏖️ Holiday"      },
  { value: "Date Night",  label: "🌙 Date Night"   },
];

export const personalTaskTypesMap = personalTaskTypes.reduce((map, type) => {
  map[type.value] = type;
  return map;
}, {});